import { render, staticRenderFns } from "./shangshiInfo.vue?vue&type=template&id=3d5c1fa4&scoped=true"
import script from "./shangshiInfo.vue?vue&type=script&lang=js"
export * from "./shangshiInfo.vue?vue&type=script&lang=js"
import style0 from "./shangshiInfo.vue?vue&type=style&index=0&id=3d5c1fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c1fa4",
  null
  
)

export default component.exports